import { render, staticRenderFns } from "./MapDetailModal.vue?vue&type=template&id=2240a668&scoped=true&"
import script from "./MapDetailModal.vue?vue&type=script&lang=js&"
export * from "./MapDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./MapDetailModal.vue?vue&type=style&index=0&id=2240a668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2240a668",
  null
  
)

export default component.exports